import React from 'react';
import { useSelector } from 'react-redux';
import { Toast, ToastContainer } from 'react-bootstrap';
import AlertVariant from './AlertVariant';

function AlertContainer() {
  const {
    text,
    variant = AlertVariant.PRIMARY,
    open,
  } = useSelector((state) => ({
    text: state.alert.get('text'),
    variant: state.alert.get('variant'),
    open: state.alert.get('show'),
  }));

  const getText = () => (typeof text === 'object' ? text?.message : text);

  if (!text) return null;

  return (
    <ToastContainer className="position-fixed top-0 end-0 p-3">
      <Toast show={open} delay={3000} autohide bg={variant}>
        <Toast.Body className="text-white fw-semibold">{getText()}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
}

export default AlertContainer;
